const $$splitComponentImporter = () => import('/home/runner/work/inspecttec-frontend-admin/inspecttec-frontend-admin/src/routes/support/settings.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { Permissions } from "@/constants/permissions";
import { requirePermission } from "@/lib/auth/permission-guard";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/support/settings")({
  beforeLoad: args => requirePermission(Permissions.Support.ViewTickets, args),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});

/** Staff email copies: on/off and where they go (stored in the SupportSettings row). */